import { Container } from '@mui/material';
import { navigate, type PageProps } from 'gatsby';
import React from 'react';
import { useSearchParam } from 'react-use';

import { DrilldownHeader } from '@components/DrilldownHeader';

import * as ROUTES from '@constants/routes';
import { LAB_RESULTS } from '@constants/routes';

import AppLayout from '@layouts/AppLayout';

import Trend from '@views/Records/LabResults/Trend';

export default function LabResultsReportDetailPage(_props: PageProps) {
  const category = useSearchParam('category');
  const code = useSearchParam('code');
  const title = useSearchParam('title');

  React.useEffect(() => {
    if (!code && !category) {
      navigate(ROUTES.LAB_RESULTS);
    }
  }, [code, category]);

  return (
    <AppLayout friendlyName={title}>
      <DrilldownHeader backRoute={LAB_RESULTS} showBackground title={title} />
      <Container>
        <Trend type={category ?? undefined} test={code ?? undefined} />
      </Container>
    </AppLayout>
  );
}
